export const manageJobs = {
  jobRequestRow: {
    buttons: {
      cancel: 'Cancel All'
    }
  }
};
